'use strict';

const _ = require('underscore');
const Backbone = require('backbone/backbone');
// const Constants = require('constants/Constants');
const Events = require('constants/Events');
require('./IndexResultsCard.less');

//a 3D rendering library
const THREE = require('three');

//a library to load 3ds models into three js
const TDSLoader = require('three-3dsloader');

const Selectors = {
    el: '.IndexResultsCard',
    lastItem: '.IndexTailored-item:last-child'
};

const Assets = {
    folderAttr: 'data-assets-folder',

    card3d: 'card.3ds',

    textureCardTop: 'Card_Color_Top.jpg',
    textureCardMiddle: 'Card_Color_Middle.jpg',
    textureCardBottom: 'Card_Color_Bottom.jpg',
    textureChip: 'Chip_Color.jpg'
};

const BindFunctions = [
    'init3DScene',
    'initTextureLoader',
    'getTextures',
    'onResize',
    'onLoadCanvas',
    'onScroll'
];

const cameraFarPlane = 1000;
const cameraFOV = 40;
const cameraNearPlane = 0.1;

const card3dWidth = 13.71; //from 3ds model
const card3dHeight = 21.732;
const card3dAspect = card3dWidth / card3dHeight;

const settings = {
    card: {
        position: [-1.229, -0.659, 0],
        rotation: [-1.611, -0.358, 0.318]
    },
    pointLight: {
        position: [-3.271, 18.572, 8.671]
    },
    camera: {
        position: [0, 0, 94.596]
    }
};

module.exports = Backbone.View.extend({

    el: Selectors.el,

    initialize: function (options = {}) {
        _.bindAll(this, BindFunctions);

        this.options = options;

        this.initTextureLoader();

        app.vent.on(Events.home.results.cardResize, this.onResize);
        // app.vent.on(Events.home.hero.sequenceEnded, this.onResize);
        app.vent.on(Events.common.pageLoaded, this.onResize);
    },

    initTextureLoader: function () {
        this.folder = this.$el.attr(Assets.folderAttr);

        const texturesSRC = [
            Assets.textureCardTop,
            Assets.textureCardMiddle,
            Assets.textureCardBottom,
            Assets.textureChip
        ].map(texture => this.folder + texture);

        Promise.all(this.getTextures(texturesSRC))
            .then((textures) => {
                return new Promise((resolve) => {
                    this.init3DScene(textures, resolve);
                });
            })
            .then(this.onResize)
            .then(this.onLoadCanvas)
            .catch(err => console.error(err));
    },

    getTextures: function (texturesSources) {
        const loader = new THREE.TextureLoader();

        return texturesSources.map(textureSource => {
            return new Promise((resolve, reject) => {
                loader.load(
                    textureSource,
                    texture => {
                        resolve(texture);
                    },
                    undefined,
                    err => reject(err)
                );
            });
        });
    },

    init3DScene: function (textures, resolve) {
        this.textures = textures || [];

        //selecting a renderer to use
        this.renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true
        });

        // this.renderer.outputEncoding = THREE.sRGBEncoding;
        this.renderer.physicallyBasedShading = true;
        this.renderer.setPixelRatio(window.devicePixelRatio || 1); //set retina for uses devices
        this.$el.append(this.renderer.domElement);

        //initialize scene and camera
        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera(cameraFOV, 1, cameraNearPlane, cameraFarPlane);
        this.camera.position.set(...settings.camera.position);
        this.camera.lookAt(0, 0, 0);
        this.scene.add(this.camera);

        const ambientLight = new THREE.AmbientLight(0xffffff, 1);
        this.scene.add(ambientLight);

        this.pointLight = new THREE.PointLight(0xffffff, 0.5);

        this.pointLight.position.set(...settings.pointLight.position);

        this.scene.add(this.pointLight);


        (new TDSLoader()).load(this.folder + Assets.card3d, function (object) {
            // material without shader, material
            const materialCardTop = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                map: textures[0]
            });

            const materialCardMiddle = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                map: textures[1]
            });

            const materialCardBottom = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                map: textures[2]
            });

            const materialContacts = new THREE.MeshPhongMaterial({
                color: 0xd3deff,
                map: textures[3],
                shininess: 18,
                specular: 0xd3deff,
                transparent: true
            });

            object.children[0].material = materialContacts;
            object.children[2].material = materialCardTop;
            object.children[3].material = materialCardMiddle;
            object.children[4].material = materialCardBottom;
            object.remove(object.children[1]);

            object.children[0].position.y -= 0.02;

            object.position.set(...settings.card.position);
            object.rotation.set(...settings.card.rotation);

            this.card = object;
            this.scene.add(object);

            resolve();
        }.bind(this));
    },


    onResize: function (params) {
        this.isMobile = window.matchMedia('(max-width: 767px)').matches;

        this.resizeData = this.resizeData || {};

        if (params) {
            this.resizeData = {
                width: params.width,
                height: params.height,
                lastVideoLeft: params.lastVideoLeft,
                placeholderLeft: params.placeholderLeft,
                placeholderWidth: params.placeholderWidth,
                placeholderHeight: params.placeholderHeight,
                cardContainerHeight: params.cardContainerHeight,
                scrollVisibleStart: params.scrollVisibleStart,
                scrollStart:  params.scrollStart,
                scrollRange: params.scrollRange,
                heightLastItem: $(Selectors.lastItem)[0].getBoundingClientRect().height
            };
        }

        this.resizeData.wh = window.innerHeight;

        if (!this.resizeData || !this.renderer || this.isMobile) {
            return;
        }

        this.width = Math.ceil(this.resizeData.placeholderWidth);
        this.height = Math.round(this.width / card3dAspect);

        const tanFOV = Math.tan(cameraFOV * Math.PI / 360);
        const heightMultiplier = this.height / this.resizeData.height;

        this.camera.fov = (360 / Math.PI) * Math.atan(tanFOV * heightMultiplier);
        this.camera.aspect = this.width / this.height;
        this.camera.updateProjectionMatrix();

        this.renderer.setSize(this.width, this.height);
        this.renderer.render(this.scene, this.camera);

        $(this.renderer.domElement).css({
            'margin-left': (this.resizeData.width - this.width) / 2,
            'margin-top': (this.resizeData.height - this.height) / 2
        });

        this.createAnimations();
        this.prevProgress = null;

        this.onScroll(window.pageYOffset);
    },


    get3dTo2dProjection: function (vector3d) {
        const vector = vector3d.project(this.camera);

        vector.x = (vector.x + 1) / 2 * this.width;
        vector.y = -(vector.y - 1) / 2 * this.height;

        return vector;
    },


    createAnimations: function () {
        if (this.isMobile) {
            return;
        }

        const rd = this.resizeData;

        this.animations = [];

        const shiftX = -(rd.lastVideoLeft - rd.placeholderLeft) - (rd.width - rd.placeholderWidth) / 2;
        const shiftY = (rd.height - this.height) / 2;
        this.animations.push({
            obj: this.renderer.domElement,
            tp: 'css-translate',
            // easing: ['linearTween', 'easeInOutSine', 'linearTween'],
            cp: [
                [0, [0, 0, 0]],
                // [50, [shiftX / 2, shiftY / 2 + this.height / 3, 0]],
                [100, [shiftX,  shiftY, 0]]
            ]
        });

        this.animations.push({
            obj: this.camera,
            tp: 'position',
            cp: [
                [0, [...settings.camera.position]],
                [100, [0, 0, (card3dHeight / 2) / Math.tan(this.camera.fov * Math.PI / 360)]]
            ]
        });

        this.animations.push({
            obj: this.card,
            tp: 'position',
            cp: [
                [0, [...settings.card.position]],
                [100, [0, 0, 0]]
            ]
        });

        this.animations.push({
            obj: this.card,
            tp: 'rotation',
            cp: [
                [0, [...settings.card.rotation]],
                [100, [-180 * Math.PI / 360, 0, 0]]
            ]
        });
    },

    onLoadCanvas: function () {
        app.vent.on(Events.common.scroll, this.onScroll);
        this.onScroll(window.pageYOffset);
    },


    onScroll: function (scrollTop) {
        if (this.isMobile) {
            return;
        }

        if (!this.card) {
            return;
        }

        const progressRaw = 100 * (scrollTop - this.resizeData.scrollStart) / this.resizeData.scrollRange;
        const progress = Math.max(Math.min(progressRaw, 100), 0);

        const opacityStart = this.resizeData.scrollVisibleStart;
        // const opacityEnd = this.resizeData.scrollVisibleStart + this.resizeData.wh / 2;
        const opacityEnd = this.resizeData.scrollVisibleStart + this.resizeData.heightLastItem / 2;
        const opacity = Math.min(Math.max((scrollTop - opacityStart) / (opacityEnd - opacityStart), 0), 1);

        if (opacity !== this.canvasOpacity) {
            $(this.renderer.domElement).css('opacity', opacity);
            this.canvasOpacity = opacity;
        }

        if (progress === this.prevProgress) {
            return;
        }

        this.prevProgress = progress;

        const getInterpolated = (cp, easing, progress) => {
            const len = cp.length;
            let prevPercentage = 0;
            easing = easing || [];

            for (let i = 0; i < len; i++) {
                let percentage = cp[i][0];
                let points = cp[i][1];

                if (percentage === progress) {
                    return points;
                }

                if (percentage > progress) {
                    const localProgress = (progress - prevPercentage) / (percentage - prevPercentage);
                    const res = [];

                    for (let j = 0; j < points.length; j++) {
                        res[j] = app.utils.easingFunctions(cp[i - 1][1][j], points[j], localProgress, easing[i] || 'easeInOutSine');
                    }

                    return res;
                }

                prevPercentage = percentage;
            }
        };

        this.animations.forEach(function (item) {
            const res = getInterpolated(item.cp, item.easing, progress);

            if (item.tp === 'position') {
                item.obj.position.set(...res);
            }
            if (item.tp === 'rotation') {
                item.obj.rotation.set(...res);
            }

            if (item.tp === 'css-translate') {
                $(item.obj).css('transform', 'translate3d(' + res[0] + 'px, ' + res[1] + 'px, ' + res[2] + 'px)');
            }
        });

        this.renderer.render(this.scene, this.camera);
    }
});
